import { useAccountData } from 'root/src/client/v2/userData/hooks/useAccountData';
export function useDeliveryRatio() {
    const accountData = useAccountData();
    const { deliveryRatioNumerator = 0, deliveryRatioDenominator = 0 } = accountData || {};
    if (!deliveryRatioDenominator) {
        return 0;
    }
    return Math.min(deliveryRatioNumerator / deliveryRatioDenominator, 1);
}
